import { useLocation, useParams } from 'quartz-routing/react-router';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
import { usePagination } from '../pagination';
import { MY_LEARNING_FILTERS } from './myLearningConsts';
export const useMyLearningParams = () => {
  const {
    search
  } = useLocation();
  const {
    currentPage: page
  } = usePagination();
  const {
    tab = 'all'
  } = useParams();
  const [[progressType]] = useSearchParam(FILTER_TYPES.PROGRESS_STATUS);
  const [[searchTerm]] = useSearchParam(FILTER_TYPES.SEARCH);
  const [[hasCertification]] = useSearchParam(FILTER_TYPES.AWARD_TYPE);
  const [contentTypes] = useSearchParam(FILTER_TYPES.CONTENT_TYPE);
  const [[visibilityGroup]] = useSearchParam(FILTER_TYPES.CONTENT_SOURCE);
  const urlParams = new URLSearchParams(search);
  const isAnyFilterSelected = MY_LEARNING_FILTERS[tab].some(filter => urlParams.has(filter));
  return {
    tab,
    page: page || 1,
    isAnyFilterSelected,
    progressType,
    searchTerm,
    hasCertification: hasCertification === 'ONLY_SHOW_CERTIFICATE_COURSES' ? true : undefined,
    contentTypes,
    visibilityGroup
  };
};